import type { ReactNode } from "react";
import type {
  MapFunctions,
  MapProps,
  MapSearchProps,
  SearchBoxHandle,
  SearchHook,
  SearchHookOptions,
  SupportedProvider,
} from "../types";

import * as Mapbox from "./mapbox";
import * as Maptiler from "./maptiler";

import * as mapboxFunctions from "./mapbox/functions";
import * as maptilerFunctions from "./maptiler/functions";

export function getMapComponents<T>(provider: SupportedProvider): {
  MapComponent: (props: MapProps<T, any>) => ReactNode;
  SearchBox: (props: MapSearchProps) => ReactNode;

  useMapSearch: (opts: SearchHookOptions) => SearchHook;
} {
  switch (provider) {
    case "mapbox":
      return Mapbox;
    case "maptiler":
      return Maptiler;
  }
}

export function getMapFunctions(provider: SupportedProvider): MapFunctions {
  switch (provider) {
    case "mapbox":
      return mapboxFunctions;
    case "maptiler":
      return maptilerFunctions;
  }
}
